import { useState, useEffect } from "react";
import { useFirestoreConnect } from "react-redux-firebase";
import { useSelector } from "react-redux";
import { first, last } from "lodash";
import Notiflix from "notiflix";

export function useDishesList(props) {

  const [forwardPointer, setForwardPointer] = useState(null); // Forward pointer
  const [page, setPage] = useState(0); // current  page
  const [limit, setLimit] = useState(5); // limit
  const [Firstp, setFirstp] = useState(null); // Forward pointer

  useFirestoreConnect([
    {
      collection: "DishDetails",
      where: [
        ["bizId", "==", props.id],
        ["dishMenuId", "==", props.menuID],
      ],
      orderBy: [
        ["timestamp", "asc"],
        ["dishID", "asc"],
      ],
      limit: limit,
      startAfter: [forwardPointer, Firstp],
    }
  ]);

  const Dishes = useSelector(({ firestore: { ordered } }) => ordered.DishDetails);

  // add pointer to back chain

  const handlePageChange = (newPage) => {
    if (Dishes) {
      if (Dishes.length < limit) {
        Notiflix.Notify.Warning("List of dishes ends");
        window.location.reload(false);
      } else {
        setForwardPointer(last(Dishes)?.timestamp);
        setFirstp(last(Dishes)?.DishID);
      }
      if (Dishes.length === 0) {
        window.location.reload(false);
      }
      //   setFirstp(first(Dishes)?.timestamp);
      //   setForwardPointer(last(Dishes)?.timestamp);
      //   setPointer(forwardPointer);
    }
  };

  return { Dishes, limit, setLimit, page, handlePageChange };
}
